export const mapUnicodeCharactersToAscii = (str: string): string =>
  Object.entries(unicodeToAsciiMap).reduce(
    (mappedStr, [unicodeChar, asciiChar]) => mappedStr.replace(new RegExp(unicodeChar, 'g'), asciiChar),
    str
  );

const unicodeToAsciiMap: { [unicode: string]: string } = {
  ['’']: "'",
  ['‘']: "'",
  ['“']: '"',
  ['”']: '"',
  ['„']: ',,',
  ['…']: '...',
  ['—']: '-',
  ['–']: '-',
};
